import styled from "styled-components";

export const AudioPlayerContainerSC = styled.div`
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  display: flex;
  position: relative;
  width: var(--audio-player-width);
  padding-left: 1em;
  height: 100%;
`;

export const WaveWrapperSC = styled.div`
  height: calc(var(--audio-player-width) - 1em);
  width: 100%;
  canvas {
    height: calc(var(--audio-player-width) - 1em) !important; /* Force canvas to follow wrapper */
  }
`;

export const AudioPlayerWrapperSC = styled.div<{
  length: number | null;
}>`
  width: ${({ length }) => (length ? `${length}px` : "100%")};
  transform: rotate(90deg);
  position: absolute;
  top: ${({ length }) =>
    length ? `calc((${length}px / 2) - calc(var(--audio-player-width) / 2))` : 0};
  height: var(--audio-player-width);
`;
